import React from 'react'
import Chat from '../Chat/Chat'
import { useSelector } from 'react-redux'
import { selectUser } from '../User/userSlice'

const Live = () => {
    const user = useSelector(selectUser);
    return (
        <div>
            <iframe
                src="https://www.youtube.com/embed/live_stream?channel=UCQtLE3n3rSmn1NE4t5vGW6A"
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                scrolling="auto"
                height="340"
                width="100%"
            ></iframe>
            <Chat user={user?.id} />
        </div>
    )
}

export default Live
